import Vue from "vue";
import Config from "@/config";
import {applyAreaUpdateFromPayload, applyEventUpdateFromPayload} from "@/utils/task";

const mutations = {
    eventItems: (state, payload) => {
        console.log("MUTATION eventItems", payload);
        state.page.events.items = payload?.events?.items;
    },
    eventReadAll: (state, payload) => {
        console.log("MUTATION eventReadAll", payload);

        if ( payload?.isFromServer ) {
            applyEventUpdateFromPayload(state, payload);
            applyAreaUpdateFromPayload(state, payload);
        }
    },
    eventRead: (state, payload) => {
        console.log("MUTATION notificationRead", payload);

        if ( payload?.isFromServer ) {
            applyEventUpdateFromPayload(state, payload);
            applyAreaUpdateFromPayload(state, payload);
        }
    },
    eventUserUpdate: (state, payload) => {
        console.log("MUTATION eventUserUpdate", payload);

        if ( payload?.isFromServer ) {
            applyEventUpdateFromPayload(state, payload);
            applyAreaUpdateFromPayload(state, payload);
        }
    },
    /*notificationRemind: (state, payload) => {
        console.log("MUTATION notificationRemind", payload);
    },


    */
};

export default mutations;
